package org.zq.astrock_ai.util

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date.now().toLong()
